import React from "react"
import './Switch.css'

function Switch(props) {

    return (
        <div className="switch__container">
            <div className="componente">{props.name}:</div>
            <input id="switch-shadow" className="switch switch--shadow" type="checkbox" {...props}/>
            <label htmlFor="switch-shadow"></label>
        </div>
    )
}

export default Switch